// extracted by mini-css-extract-plugin
export var leftAlign = "_1l-2";
export var popper = "_1l-0";
export var subtitle = "_1l-1";